<template>
  <div>
    <div class="heat-map"></div>
    <div class="heat-map-info">
      <div class="heat-map-info__label">
        Heatmap Active
      </div>
      <div class="heat-map-info__data">
        Interactions: {{ this.heatMapDataPoints.length }}
      </div>
      <div v-if="heatMapRange.length" class="heat-map-info__data">
        Date Range: {{ convertTimestampToDate(heatMapRange[0]) + ' - ' + convertTimestampToDate(heatMapRange[1]) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import h337 from 'heatmap.js'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      heatMapData: [],
      heatMapInstance: null,
      remHeight: 108,
      remWidth: 192,
      index: 0
    }
  },

  watch: {
    $route () {
      this.updatedHeatMap()
    }
  },

  computed: {
    ...mapGetters({
      appScale: 'appScale',
      heatMap: 'interactions/heatMap',
      heatMapRange: 'interactions/heatMapRange',
    }),

    heatMapDataPoints () {
      const pageDataPoints = this.heatMapData.filter(data => data.pageUrl === this.pageUrl)

      return pageDataPoints.map(dataPoint => {
       return {
          x: parseInt(this.remWidth * dataPoint.coordinates.x * this.appScale * 10),
          y: parseInt(this.remHeight * dataPoint.coordinates.y * this.appScale * 10),
          value: 1
        }
      })
    },

    pageUrl () {
      const startIndex = this.$route.fullPath.indexOf('showHeat')
      if (startIndex > 0) {
        return this.$route.fullPath.slice(0, startIndex - 1)
      } else {
        return this.$route.fullPath
      }
    }
  },

  async mounted () {
    let interactions = []
    if (this.heatMapRange.length) {
      interactions = await axios.get(process.env.VUE_APP_API_HOST + '/interactions/datetime/' + this.heatMapRange[0] + '/'+ this.heatMapRange[1])
    } else {
      interactions = await axios.get(process.env.VUE_APP_API_HOST + '/interactions')
    }
    this.heatMapData = interactions.data
    this.setHeatMap()
  },

  methods: {
    convertTimestampToDate (timestamp) {
      return DateTime.fromMillis(Number(timestamp)).toLocaleString({ 
        month: 'long', 
        day: 'numeric',
        year: 'numeric',
      })
    },

    setHeatMap () {
      let config = {
        container: document.querySelector('.heat-map'),
        radius: 20,
        maxOpacity: .75,
        minOpacity: 0,
        blur: .85
      }

      this.heatMapInstance = h337.create(config)

      this.heatMapInstance.setData({ 
        data: this.heatMapDataPoints
      })
    },

    updatedHeatMap () {
      this.heatMapInstance.setData({ 
        data: this.heatMapDataPoints
      })
    }
  }
}
</script>

<style lang="scss">
.heat-map {
  bottom: 0;
  left: 0;
  position: absolute !important;
  right: 0;
  top: 0;
  z-index: 10000;

  canvas {
    height: 100%;
    width: 100%;
  }
}

.heat-map-info {
  background: rgba(0, 0, 0, .6);
  left: 0;
  padding: 1rem;
  position: absolute;
  top: 0;
  width: 40rem;
  z-index: 10001;

  &__label {
    font-size: 1.2rem;
    font-weight: 700;
  }

  &__data {
    font-size: 1.1rem;
  }
}
</style>